import React from 'react';
import { NavLink } from 'react-router';
import styles from './SidebarItem.module.css';

interface SidebarItemProps {
    label: string;
    path: string;
    iconSrc: string;
}

const SidebarItem: React.FC<SidebarItemProps> = ({ label, path, iconSrc }) => {
    return (
        <NavLink
            to={path}
            className={({ isActive }) => `${styles.sidebarItem} ${isActive ? styles.active : ''}`}
        >
            <img src={iconSrc} alt={`${label} icon`} className={styles.sidebarItemIcon} />
            <span>{label}</span>
        </NavLink>
    );
};

export default SidebarItem;
